import * as React from 'react';
import { useDispatch } from 'react-redux';

import * as colors from '../../shared/colors';
import t from '../../shared/translations';
import Modal from '../components/Modal';
import { Dispatch, openModal } from '../state';
import Send from './Send';

interface IProps {
    color?: string;
    padding?: string;
}

function SendButton({ color, padding }: IProps): JSX.Element {
    const dispatch = useDispatch<Dispatch>();

    const openSend = () => {
        dispatch(openModal('Messages/Send'));
    };

    const style: React.CSSProperties = {
        backgroundColor: color ?? colors.primaryColor,
        padding,
    };

    return <>
        <button onClick={openSend} type='button' style={style}>
            {t('player.messages.button-send-message')}
        </button>
        <Modal modal='Messages/Send'>
            <Send />
        </Modal>
    </>;
}

export default SendButton;
